import { ArrayDataSource } from './BaseDataSources';
import { IDiligenceExceptionStatus } from '../Interfaces';

export class DiligenceExceptionStatusSource extends ArrayDataSource<IDiligenceExceptionStatus> {
  public constructor() {
    super('/datasource/diligenceexceptionstatuses');
  }
}